import * as yup from 'yup'
import { TrustedPersonForm } from '../../../enums'
import { yupEmail, yupPhone } from '@shared/utils'

export const useSchema = (t: (translation: string) => string) => {
  return yup.object().shape({
    [TrustedPersonForm.phone]: yupPhone(t),
    [TrustedPersonForm.email]: yupEmail(t),
  })
}
